/**
 * @voltxampere/engine — LED AC small-signal stamp (Sprint 23 B1)
 *
 * Diode AC stamp'ının LED-default sarmalı. `Is`/`N` LED
 * default'larına çevrilir, sonra `diodeACStamp` çağrılır.
 * Junction-cap parametreleri (Cj0, Vj, M, Tt, FC) LED için de
 * aynı SPICE3 form (additive, zero-default).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diodeACStamp } from "./diode.js";
import { getNumericParam } from "../terminal-utils.js";
const LED_DEFAULT_IS = 1e-12;
const LED_DEFAULT_N = 3;
export const ledACStamp = (ctx, component) => {
    const enrichedParams = {
        ...component.params,
        saturationCurrent: getNumericParam(component, "saturationCurrent", LED_DEFAULT_IS),
        ideality: getNumericParam(component, "ideality", LED_DEFAULT_N),
    };
    diodeACStamp(ctx, { ...component, params: enrichedParams });
};
//# sourceMappingURL=led.js.map